// Data router (DESIGN_SPEC §11.1). createBrowserRouter + RouterProvider is what lets
// <NavLink viewTransition> run document.startViewTransition (a declarative <BrowserRouter> never does).
// Route ids feed the keyboard sheet; handles carry the default title and the atmosphere flag.
//   /            landing     malbox            atmosphere "hero" (storefront)
//   /submit      submit      Submit            atmosphere "hero" (footer joins the page's .flat band)
//   /jobs        analyses    Analyses
//   /jobs/:id    report      Report
//   *            not-found   404               atmosphere "full"
// Errors thrown while a page renders show inside the shell (pathless boundary); a shell error
// falls back to the bare error page.
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import { Layout } from "@/components/shell/Layout";
import { RouteError } from "@/components/shell/RouteError";
import type { RouteHandle } from "@/components/shell/routeHandle";
import { ChangelogPage } from "@/pages/ChangelogPage";
import { DocsPage } from "@/pages/DocsPage";
import { JobDetailPage } from "@/pages/JobDetailPage";
import { JobsPage } from "@/pages/JobsPage";
import { LandingPage } from "@/pages/LandingPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PricingPage } from "@/pages/PricingPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { SecurityPage } from "@/pages/SecurityPage";
import { StatusPage } from "@/pages/StatusPage";
import { SubmitPage } from "@/pages/SubmitPage";
import { TermsPage } from "@/pages/TermsPage";

const handle = (h: RouteHandle) => h;

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<Layout />} errorElement={<RouteError bare />}>
      <Route errorElement={<RouteError />}>
        <Route id="landing" index element={<LandingPage />} handle={handle({ title: "malbox", atmosphere: "hero" })} />
        <Route id="submit" path="submit" element={<SubmitPage />} handle={handle({ title: "Submit · malbox", atmosphere: "hero" })} />
        <Route id="analyses" path="jobs" element={<JobsPage />} handle={handle({ title: "Analyses · malbox" })} />
        <Route id="report" path="jobs/:id" element={<JobDetailPage />} handle={handle({ title: "Analysis · malbox" })} />
        <Route id="docs" path="docs" element={<DocsPage />} handle={handle({ title: "Docs · malbox" })} />
        <Route id="changelog" path="changelog" element={<ChangelogPage />} handle={handle({ title: "Changelog · malbox" })} />
        <Route id="status" path="status" element={<StatusPage />} handle={handle({ title: "Status · malbox" })} />
        <Route id="pricing" path="pricing" element={<PricingPage />} handle={handle({ title: "Pricing · malbox" })} />
        <Route id="security" path="security" element={<SecurityPage />} handle={handle({ title: "Security · malbox" })} />
        <Route id="privacy" path="privacy" element={<PrivacyPage />} handle={handle({ title: "Privacy · malbox" })} />
        <Route id="terms" path="terms" element={<TermsPage />} handle={handle({ title: "Terms · malbox" })} />
        <Route id="not-found" path="*" element={<NotFoundPage />} handle={handle({ title: "Not found · malbox", atmosphere: "full" })} />
      </Route>
    </Route>,
  ),
);
